export default __webpack_public_path__ + "static/media/MONGO_ico.b46cf16f.svg";